/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CreateEnumerationValueListDto } from './CreateEnumerationValueListDto';
import {
    instanceOfCreateEnumerationValueListDto,
    CreateEnumerationValueListDtoFromJSON,
    CreateEnumerationValueListDtoFromJSONTyped,
    CreateEnumerationValueListDtoToJSON,
} from './CreateEnumerationValueListDto';
import type { CreateNumericDataSetFilterDto } from './CreateNumericDataSetFilterDto';
import {
    instanceOfCreateNumericDataSetFilterDto,
    CreateNumericDataSetFilterDtoFromJSON,
    CreateNumericDataSetFilterDtoFromJSONTyped,
    CreateNumericDataSetFilterDtoToJSON,
} from './CreateNumericDataSetFilterDto';
import type { CreateTextValueListDto } from './CreateTextValueListDto';
import {
    instanceOfCreateTextValueListDto,
    CreateTextValueListDtoFromJSON,
    CreateTextValueListDtoFromJSONTyped,
    CreateTextValueListDtoToJSON,
} from './CreateTextValueListDto';

/**
 * @type ICreateSetupParameterFilter
 * 
 * @export
 */
export type ICreateSetupParameterFilter = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.CreateEnumerationValueListDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreateEnumerationValueListDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.CreateNumericDataSetFilterDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreateNumericDataSetFilterDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateTextValueListDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreateTextValueListDto;


export function ICreateSetupParameterFilterFromJSON(json: any): ICreateSetupParameterFilter {
    return ICreateSetupParameterFilterFromJSONTyped(json, false);
}

export function ICreateSetupParameterFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICreateSetupParameterFilter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.CreateEnumerationValueListDto, Ptw.Ptw100.AppZero.Application.Shared':
            return {...CreateEnumerationValueListDtoFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.CreateEnumerationValueListDto, Ptw.Ptw100.AppZero.Application.Shared'};
        case 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.CreateNumericDataSetFilterDto, Ptw.Ptw100.AppZero.Application.Shared':
            return {...CreateNumericDataSetFilterDtoFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.CreateNumericDataSetFilterDto, Ptw.Ptw100.AppZero.Application.Shared'};
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateTextValueListDto, Ptw.Ptw100.AppZero.Application.Shared':
            return {...CreateTextValueListDtoFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateTextValueListDto, Ptw.Ptw100.AppZero.Application.Shared'};
        default:
            throw new Error(`No variant of ICreateSetupParameterFilter exists with '$type=${json['$type']}'`);
    }
}

export function ICreateSetupParameterFilterToJSON(value?: ICreateSetupParameterFilter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.CreateEnumerationValueListDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreateEnumerationValueListDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.CreateNumericDataSetFilterDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreateNumericDataSetFilterDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateTextValueListDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreateTextValueListDtoToJSON(value);
        default:
            throw new Error(`No variant of ICreateSetupParameterFilter exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the ICreateSetupParameterFilter interface.
 */
export function instanceOfICreateSetupParameterFilter(value: any): value is ICreateSetupParameterFilter {
    if (instanceOfCreateEnumerationValueListDto(value)) return true;
    if (instanceOfCreateNumericDataSetFilterDto(value)) return true;
    if (instanceOfCreateTextValueListDto(value)) return true;
    return false;
}

